import { DEFAULT_ACCEPTANCE_ADVANCED_ID } from './consts';

export const selectAcceptanceAdvancedState = (state: RootState) => state.acceptanceAdvanced;

export const selectAcceptanceAdvancedById =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId];

export const selectIsAcceptanceAdvancedSigningLoading =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId]?.loading || false;

export const selectAcceptanceAdvancedError =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId]?.error;

export const selectAcceptanceAdvancedLink =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId]?.acceptanceAdvancedTabUrl;

export const selectIsAcceptanceAdvancedPolling =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) =>
    Boolean(state.globalPolling.activePolls[acceptanceAdvancedId]);

export const selectAcceptanceAdvancedContext =
  (acceptanceAdvancedId = DEFAULT_ACCEPTANCE_ADVANCED_ID) =>
  (state: RootState) => {
    const data = state.acceptanceAdvanced.acceptancesAdvanced[acceptanceAdvancedId];
    if (!data) return null;

    return {
      hasActiveTab: data.acceptanceAdvancedTabOpened || false,
      tabUrl: data.acceptanceAdvancedTabUrl,
    };
  };
